import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Appeals from "./pages/Appeals";
import Scholarships from "./pages/Scholarships";
import UserGuide from "./pages/UserGuide";

import { connect } from "react-redux";

import { getTransferEligibility } from "../../../store/transfer/actions";

const Layout = (props) => {
  useEffect(() => {
    document.title = "TMIS | Transfers";
  }, []);

  const { user, getTransferEligibility } = props;

  useEffect(() => {
    getTransferEligibility();
  }, []);

  return (
    <React.Fragment>
      <Switch>
        <Route path="/in/scholarship/dashboard" component={Dashboard} />
        <Route path="/in/scholarship/requests" component={Scholarships} />
        <Route path="/in/scholarship/appeals" component={Appeals} />
        <Route path="/in/scholarship/user-guide" component={UserGuide} />
      </Switch>
    </React.Fragment>
  );
};

const mapStateToProps = ({ user }) => {
  return {
    user,
  };
};
export default connect(mapStateToProps, { getTransferEligibility })(Layout);
